import { Component } from 'react';
import {connect} from "react-redux";
import ReactTable from '../../components/Table/ReactTable';
import {getUnitLabel} from '../../redux/absences/absencesActions'

class AbsenceCounters extends Component {

    constructor(props) {
        super(props);

        this.state = {
            columns:[
                {
                    Header: "Compteurs",
                    columns: [
                        {
                            Header: "Type",
                            accessor: "type",
                            maxWidth: 120,
                        },
                        {
                            Header: "Solde",
                            accessor: 'value',
                            width: 70,
                        },
                        {
                            Header: "Unité",
                            id: 'value_type',
                            width: 50,
                            accessor: c => getUnitLabel(c.value_type),
                        },
                        {
                            Header: "P + 1",
                            accessor: 'value_in_progress',
                            width: 50,
                        },
                    ]
                },
            ]
        }
    }

    render() {
        let counters = this.props.absences.absenceCreationFields.counters;

        if(!counters || counters.length <= 0){
            return (<div/>);
        }

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <div className="row">
                    <ReactTable
                        data={counters}
                        columns={this.state.columns}
                        minRows={3}
                        defaultPageSize={100}
                        pageSize={100}
                        showPagination = {false}
                        previousText= 'Précédent'
                        nextText= 'Suivant'
                        loadingText= 'Chargement...'
                        noDataText= 'Aucun résultat'
                        pageText= 'Page'
                        ofText= 'sur'
                        rowsText= 'lignes'
                        className="-striped -highlight col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding"
                        style={{
                            height: "100%", //This will force the table body to overflow and scroll, since there is not enough room
                            overflow: "visible",
                            fontSize: '0.8em',
                        }} />
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        absences: state.absences,
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AbsenceCounters);
